import React, { useEffect, useState } from 'react';
import firebase from '../../config/firebase.config';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { TabBar } from '@/components/TabBar';
import styles from './InviteesList.module.scss';
import { Table } from '@/components/Table';
import { EmptyState } from '@/components/EmptyState';
import {
  projectInviteListConfig,
  teamInviteListConfig,
} from './InviteesList.config';
const database = firebase.firestore();
const tabs = [
  {
    label: 'Department Invites',
    value: 'teamInvites',
  },
  {
    label: 'Project Invites',
    value: 'projectInvites',
  },
];

export const InviteesListComponent = () => {
  const { profile } = useSelector((state) => state.auth);
  const [inviteData, setInviteData] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const [isList, setIsList] = useState(true);
  const [empty, setEmpty] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  // get User Data
  const getUser = async () => {
    setInviteData([]);
    try {
      await database
        .collection('membersDatabase')
        .where('accountEmailid', '==', profile?.email)
        .get()
        .then((memberData) => {
          const data = memberData.docs.map((res) => res.data());
          if (data[0]?.teamInvites?.length === 0) {
            setIsList(true);
          } else {
            setEmpty(false);
            for (let i = 0; i <= data[0]?.teamInvites?.length; i++) {
              try {
                database
                  .collection('userInvites')
                  .doc(data[0].teamInvites[i])
                  .get()
                  .then((response) => {
                    if (response.data() !== undefined) {
                      setInviteData((old) => [
                        ...old,
                        {
                          data: response.data(),
                          docId: data[0].teamInvites[i],
                        },
                      ]);
                    }
                  });
              } catch (error) {
                return error;
              }
            }
          }
        });
    } catch (error) {
      return error;
    }
    setIsList(false);
  };

  const openModal = (docId) => {
    history.push(`invites/${docId}`);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    localStorage.removeItem('ItemCount');
    localStorage.setItem('Visited', true);
    if (profile?.companyList?.length === 1) {
      if ('list' in localStorage) {
        const list = localStorage.getItem('list');
        localStorage.removeItem('list');
        if (list === 1) {
          localStorage.setItem('teamData', []);
          dispatch({
            type: teamActionTypes.SWITCH_COMPANY_ACTIVE_TEAM,
            payload: {
              companyId: profile?.companyList[0].companyId,
              userId: profile?.id,
            },
          });
        }
      }
    }
    getUser();
  }, []);
  const getTeamInviteTableData = () => {
    const tableData = [];
    inviteData.forEach((invite, key) => {
      if (invite?.data?.invitedAs !== 'Client' && !invite?.data?.declined) {
        tableData.push({
          id: key + 1,
          role: invite?.data?.invitedAs,
          invitedBy: invite?.data?.invitedBy?.fullName,
          company: invite?.data?.invitedBy?.companyDetails?.companyName,
          team: invite?.data?.invitedTo?.teamName,
          docId: invite?.docId,
        });
      }
    });
    return tableData;
  };
  const getProjectInviteTableData = () => {
    const tableData = [];
    inviteData.forEach((invite, key) => {
      if (invite?.data?.invitedAs === 'Client' && !invite?.data?.declined) {
        tableData.push({
          id: key + 1,
          role: invite?.data?.invitedAs,
          invitedBy: invite?.data?.invitedBy?.fullName,
          company: invite?.data?.invitedBy?.companyDetails?.companyName,
          project: invite?.data?.project[0]?.label,
          docId: invite?.docId,
        });
      }
    });
    return tableData;
  };
  useEffect(() => {
    if (activeTab === tabs[0].value) {
      setTableData(getTeamInviteTableData());
    } else {
      setTableData(getProjectInviteTableData());
    }
  }, [activeTab, inviteData]);
  return (
    <>
      <div className={styles.inviteesListPage}>
        <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
        {tableData.length === 0 ? (
          <EmptyState
            illustration
            title="No Invites Found"
            description="You don't have any invites to review right now."
          />
        ) : (
          <Table
            className={styles.table}
            data={tableData}
            columns={
              activeTab === tabs[0].value
                ? teamInviteListConfig(openModal)
                : projectInviteListConfig(openModal)
            }
          />
        )}
      </div>
    </>
  );
};
